import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var GET_WISHLISTS = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query GetWishlists {\n        customer {\n            wishlists {\n                id\n                name\n                items_count\n            }\n        }\n    }\n"])));